import classNames from 'classnames';
import { AriaAttributes, ButtonHTMLAttributes, FC, HTMLAttributes } from 'react';

import style from './icon-button.module.css';

type HtmlButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & HTMLAttributes<HTMLButtonElement>;

export type ButtonProps = HtmlButtonProps;

type ButtonPropsWithAriaLabel = ButtonProps & Required<Pick<AriaAttributes, 'aria-label'>>;

interface IconButtonPropsBase extends ButtonProps {
  round?: boolean;
}

type IconButtonProps = ButtonPropsWithAriaLabel & IconButtonPropsBase;

const IconButton: FC<IconButtonProps> = ({
  'aria-label': ariaLabel,
  children,
  round = true,
  ...htmlButtonProps
}) => {
  return (
    <button
      {...htmlButtonProps}
      aria-label={ariaLabel}
      className={classNames(
        htmlButtonProps.className,
        style.iconButton,
        {
          [style.round]: round,
        },
      )}
    >
      {children}
    </button>
  );
};

export default IconButton;
